import React, { FunctionComponent } from "react";
import styles from "./CardStep.module.scss";

const CardStep: FunctionComponent<{
  imgSrc: string;
  title: string;
  description: string;
}> = ({ imgSrc, title, description }) => {
  return (
    <div className={styles.cardStep}>
      <img
        loading="lazy"
        className={styles.cardStep_img}
        src={imgSrc}
        alt={title}
      />

      <h3 className={styles.cardStep_title}>{title}</h3>
      <p className={styles.cardStep_description}>{description}</p>
    </div>
  );
};

export default CardStep;
